import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import { useSelector } from 'react-redux'

import {
  selectPublicListingLeasingInformation,
  selectPublicListingStatus,
  selectPublicListingScreeningRequest,
  selectPublicListingAgentContactDisplayName,
  selectTextAddress,
  selectPublicListingId,
  selectPropertyId,
} from 'store/public-listing'

type ApplyButtonState = {
  text: string
  disabled: boolean
}

function processDateAvailable(date: string | undefined) {
  const currentDate = moment.utc()
  if (moment.utc(date).isSameOrBefore(currentDate)) {
    return 'Available Now'
  }
  return moment.utc(date).format('MMM DD, YYYY')
}

export function useApplyPanelData() {
  const leasingInformation = useSelector(selectPublicListingLeasingInformation)
  const displayName = useSelector(selectPublicListingAgentContactDisplayName)
  const textAddress = useSelector(selectTextAddress)
  const publicListingId = useSelector(selectPublicListingId)
  const propertyId = useSelector(selectPropertyId)
  return {
    termAmountOfMonths: 1,
    ...leasingInformation,
    displayName,
    dateAvailable: processDateAvailable(leasingInformation.dateAvailable),
    textAddress,
    publicListingId,
    propertyId,
  }
}

export function useApplyButtonState(): ApplyButtonState {
  const status = useSelector(selectPublicListingStatus)
  const screeningRequest = useSelector(selectPublicListingScreeningRequest)
  if (status !== 'draft' && !isEmpty(screeningRequest)) {
    return {
      text: 'Apply',
      disabled: false,
    }
  }
  return {
    text: 'Application Closed',
    disabled: true,
  }
}
